import { render } from "./dynamic_case_report.html?vue&type=template&id=9600fed2&scoped=true&external"
import script from "./dynamic_case_report?vue&type=script&lang=js&external"
export * from "./dynamic_case_report?vue&type=script&lang=js&external"

import "./DynamicCaseReport.vue?vue&type=style&index=0&id=9600fed2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9600fed2"]])

export default __exports__